import React from 'react';
import { filter, includes } from 'lodash';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { useTranslation } from 'hooks/useTranslation';

import { Breadcrumbs, NavTabs, WebCopy, Loader, LoaderSettings } from 'components';

import { OrganizationTypes, SettingsTabsType } from 'helpers/constants';

import styles from './Header.module.scss';

const GET_CURRENT_ORGANIZATION = gql`
  query getCurrentOrganization {
    me {
      userProfile {
        id
        organization {
          id
          name
          type
        }
      }
    }
  }
`;

const getTabs = (t: any) => [
  {
    defaultTab: true,
    key: 'apps',
    label: t('settings-screen.header.tabs.apps'),
    to: `/settings?tab=${SettingsTabsType.APPS}`,
    types: [OrganizationTypes.WORK],
  },
  {
    key: 'members',
    label: t('settings-screen.header.tabs.members'),
    to: `/settings?tab=${SettingsTabsType.MEMBERS}`,
    types: [OrganizationTypes.WORK],
  },
];

export const Header = () => {
  const { t } = useTranslation();
  const { error, data } = useQuery(GET_CURRENT_ORGANIZATION, { fetchPolicy: 'cache-and-network' });

  if (data === undefined) return <LoaderSettings />;

  if (error) return <Loader color="Red" />;

  const {
    me: {
      userProfile: {
        organization: { name: organizationName, type: organizationType },
      },
    },
  } = data;

  const filteredTabs = filter(getTabs(t), (tab) => {
    return !tab.types || includes(tab.types, organizationType);
  });

  return (
    <div>
      <Breadcrumbs
        links={[
          {
            label: t('settings-screen.header.breadcrumb'),
            to: `/settings`,
          },
        ]}
        organizationName={organizationName}
      />
      <WebCopy className={styles.copy} type="Description">
        {organizationType === OrganizationTypes.WORK && (
          <>
            {t('settings-screen.header.description.organization')}{' '}
            <strong>{organizationName}</strong>{' '}
          </>
        )}
        {organizationType === OrganizationTypes.PERSONAL &&
          t('settings-screen.header.description.personal')}
      </WebCopy>

      <NavTabs tabs={filteredTabs} />
    </div>
  );
};
